<template>
  <footer
    id="contact"
    class="bg-black text-white px-5 pt-12.5 xl:px-25 2xl:px-55 transition-[padding] relative overflow-hidden"
  >
    <div
      class="relative z-10 grid grid-cols-[max-content_50px] lg:grid-cols-[max-content_70px] grid-rows-[max-content_20px_max-content] lg:grid-rows-[70px_max-content_max-content] justify-center"
      v-reveal
    >
      <!-- grid-cols-[60px_max-content_50px] lg:grid-cols-[max-content_70px_710px] -->
      <NewsletterForm v-if="false" />
      <SiteAddress
        class="col-start-2 lg:col-start-1 col-end-4 lg:col-end-3 row-start-2 row-end-4 mb-45 lg:mb-25 lg:relative bg-dustrose text-burgundy"
      />
    </div>

    <div class="opacity-50 text-xs text-center py-2.5 leading-5 relative z-10">
      <span>{{ $t('credits').replace(':YEAR', new Date().getFullYear().toString()) }}</span>
      <span class="mx-1">|</span>
      <LangRouterLink :to="{ name: $routes.PRIVACY_POLICY }"
        >{{ $t('privacy_policy') }}
      </LangRouterLink>
      <span class="mx-1">|</span>
      <RawHtml
        tag="a"
        href="https://boitebeet.com"
        target="_blank"
        :html="$t('designed_developed_by')"
      />
    </div>

    <div
      v-if="$content.options.value.contact?.footer?.image"
      class="absolute left-0 bottom-0 w-full max-h-full"
      v-reveal="{ class: 'v-reveal-image' }"
    >
      <div class="h-1/3 lg:h-3/4 bg-gradient-to-b from-black absolute w-full top-0 left-0"></div>
      <div class="h-3/4 bg-gradient-to-t from-black absolute w-full bottom-0 left-0"></div>
      <ResponsiveImage
        :media="$content.options.value.contact.footer.image"
        class="w-full object-cover"
      />
    </div>
  </footer>
</template>

<script lang="ts">
import NewsletterForm from '@/components/blocks/NewsletterForm.vue'
import SiteAddress from '@/components/blocks/SiteAddress.vue'
import IconSprite from '@/components/helpers/IconSprite.vue'
import LangRouterLink from '@/components/helpers/LangRouterLink.vue'
import RawHtml from '@/components/helpers/RawHtml.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'SiteFooter',
  components: {
    IconSprite,
    LangRouterLink,
    NewsletterForm,
    RawHtml,
    ResponsiveImage,
    SiteAddress,
  },
}
</script>
